@if (banner) {
  <div
    class="aimo-small-banner" #bannerWrapper
        [ngClass]="{
            'text-over-image': banner.bannerImageRatio === 'SQUARE',
            'text-over-image-petrol': banner.bannerColor === 'PETROL',
        }">
    <ng-container *ngTemplateOutlet="bannerContent; context: { banner: banner, isCarousel: true, isSmall: true }">
    </ng-container>
  </div>
} @else {
  @if (componentData$ | async; as banner) {
    @if (banner.bannerType === 'HERO') {
      <!-- Hero banner background stretches full width and content is inside container -->
      <div class="aimo-hero-banner" #bannerWrapper>
        <div
          class="aimo-banner-background"
          [class]="getBgClass(banner)">
          <div class="container">
            <ng-container
                            *ngTemplateOutlet="
                                bannerContent;
                                context: { banner: banner, isCarousel: false, isSmall: false }
                            "></ng-container>
          </div>
        </div>
      </div>
    }
    @if (banner.bannerType === 'LARGE') {
      <!-- Large banner background and content are inside container -->
      <div class="aimo-large-banner" #bannerWrapper>
        <div class="container">
          <div
            class="aimo-banner-background"
            [class]="getBgClass(banner)">
            <ng-container
                            *ngTemplateOutlet="
                                bannerContent;
                                context: { banner: banner, isCarousel: false, isSmall: false }
                            "></ng-container>
          </div>
        </div>
      </div>
    }
    @if (banner.bannerType === 'SMALL') {
      <!-- Small banner is inside carousel and does not have background -->
      <div
        class="aimo-small-banner" #bannerWrapper
                [ngClass]="{
                    'text-over-image': banner.bannerImageRatio === 'SQUARE',
                }">
        <ng-container
                    *ngTemplateOutlet="
                        bannerContent;
                        context: { banner: banner, isCarousel: false, isSmall: true }
                    "></ng-container>
      </div>
    }
  }
}


<ng-template #bannerMedia let-banner="banner">
  @if (banner.youtubeId) {
    <youtube-player
      videoId="{{ banner.youtubeId }}"
        [ngClass]="{
            'image-ratio-low': banner.bannerImageRatio === 'LOW',
            'image-ratio-square': banner.bannerImageRatio === 'SQUARE',
        }"></youtube-player>
  }
  @if (banner.media && !banner.youtubeId) {
    <cx-media
      [loading]="'lazy'" [container]="banner.media"
        [ngClass]="{
            'image-ratio-low': banner.bannerImageRatio === 'LOW',
            'image-ratio-square': banner.bannerImageRatio === 'SQUARE',
            'dark-layer' : banner.darkLayer == 'true',
        }"></cx-media>
  }
</ng-template>

<ng-template #bannerContent let-banner="banner" let-isCarousel="isCarousel" let-isSmall="isSmall">
  <div class="row no-gutters">
    <div
            [ngClass]="{
                'col-md-6 col-12': !isSmall,
                'col-12': isSmall,
                'order-md-2': !isSmall && banner.bannerPosition === 'TEXT_LEFT',
                'order-md-1': !isSmall && banner.bannerPosition !== 'TEXT_LEFT',
            }">
      @if (banner.urlLink && banner.media && !banner.youtubeId) {
        @if (banner.urlLink && isExternal(banner)) {
          <a
            (click)="buttonClicked(banner)"
            [href]="getSafeUrl(banner)"
            [target]="getTarget(banner)">
            <ng-container *ngTemplateOutlet="bannerMedia; context: { banner: banner }"></ng-container>
          </a>
        }
        @if (banner.urlLink && !isExternal(banner)) {
          <a
            (click)="buttonClicked(banner)"
            [routerLink]="banner.urlLink"
            [queryParams]="banner.urlParams"
            [fragment]="banner.urlLinkFragment">
            <ng-container *ngTemplateOutlet="bannerMedia; context: { banner: banner }"></ng-container>
          </a>
        }
      }
      @if (!banner.urlLink || banner.youtubeId) {
        <ng-container *ngTemplateOutlet="bannerMedia; context: { banner: banner }"></ng-container>
      }
    </div>
    <div
            [ngClass]="{
                'col-md-6 col-12 my-auto': !isSmall,
                'col-12': isSmall,
                'order-md-1': !isSmall && banner.bannerPosition === 'TEXT_LEFT',
                'order-md-2': !isSmall && banner.bannerPosition !== 'TEXT_LEFT',
            }">
      @if (banner.headText || banner.text || banner.buttonName) {
        <div
          class="banner-content"
          [ngClass]="{'text-shadow' : banner.textShadow == 'true'}">
          @if (banner.headText) {
            <h2
              class="banner-header"
                    [ngClass]="{
                        h1: !isSmall,
                        h2: isSmall && banner.bannerImageRatio === 'SQUARE',
                        h3: isSmall && !banner.bannerImageRatio === 'SQUARE',
                    }"
            [innerHTML]="banner.headText"></h2>
          }
          @if (banner.text) {
            <div class="banner-text" [innerHTML]="banner.text|safeHtml"></div>
          }
          @if (banner.urlLink) {
            @if (banner.buttonName && isExternal(banner)) {
              <a
                class="btn"
                        [ngClass]="{
                            'btn-sm': isSmall && !banner.bannerImageRatio === 'SQUARE',
                            'btn-sm-down': !isSmall,
                            'btn-highlighted': banner.bannerColor === 'PETROL' && !(isSmall && banner.bannerImageRatio === 'SQUARE'),
                            'btn-primary': banner.bannerColor !== 'PETROL' || (isSmall && banner.bannerImageRatio === 'SQUARE'),
                        }"
                (click)="buttonClicked(banner)"
                [innerHTML]="banner.buttonName"
                [href]="getSafeUrl(banner)"
                [target]="getTarget(banner)">
              </a>
            }
            @if (banner.buttonName && !isExternal(banner)) {
              <a
                class="btn"
                        [ngClass]="{
                            'btn-sm': isSmall && !banner.bannerImageRatio === 'SQUARE',
                            'btn-sm-down': !isSmall,
                            'btn-highlighted': banner.bannerColor === 'PETROL' && !(isSmall && banner.bannerImageRatio === 'SQUARE'),
                            'btn-primary': banner.bannerColor !== 'PETROL' || (isSmall && banner.bannerImageRatio === 'SQUARE'),
                        }"
                (click)="buttonClicked(banner)"
                [innerHTML]="banner.buttonName"
                [routerLink]="banner.urlLink"
                [queryParams]="banner.urlParams"
                [fragment]="banner.urlLinkFragment">
              </a>
            }
          }
        </div>
      }
    </div>
  </div>
</ng-template>
